import React from 'react'
import InputField from './InputFeild'
import Button from './Button'
import SelectField from './SelectField'
import {useState} from "react";
import {ROOM_OPTIONS} from '../constant'

const Form = () => {
  const [roomType,setRoomType]=useState("")
  const [guest,setGuest]=useState("")
  const [date,setDate]=useState("")
  const [requirement,setRequirement]=useState("")
  const [details,setDetails]=useState("")
  const [confirm,setConfirm]=useState("")
  return (
    <form className="w-full max-w-lg mx-auto">
  <div className="flex flex-wrap justify-around my-6">
        <div className="w-full md:w-1/2 px-3 mb-6 pb-4 md:mb-0">
      <InputField type="number" value={guest} onChange={(e) => setGuest(e.target.value)} placeholder="Number of Guest"/>
    </div>
    <div className="w-full pb-4 md:w-1/2 px-3 mb-6 md:mb-0">
      <InputField type="date" value={date} onChange={(e) => setDate(e.target.value)} placeholder="Date"/>
    </div>
    <div className="w-full pb-4 md:w-1/2 px-3 mb-6 md:mb-0">
      <SelectField showOther={false}
            options={ROOM_OPTIONS}
            changeHandler={setRoomType}
            selectedValue={roomType} placeholder="Choose Room"/>
      
    </div>
    <div className="w-full pb-4 md:w-1/2 px-3 mb-6 md:mb-0">
      <InputField type="text" value={requirement} onChange={(e) => setRequirement(e.target.value)} placeholder="Special Requirement"/>
      
    </div>
     <div className="w-full pb-4 md:w-1/2 px-3 mb-6 md:mb-0">
      <InputField type="text" value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Details"/>
      
    </div>
     <div className="w-full pb-4 md:w-1/2 px-3 mb-6 md:mb-0">
      <InputField type="text" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirmation"/>
      
    </div>
 
  <div className="flex flex-wrap -mx-3 mb-6">
    <div className="mx-auto">
      <Button href="/inquiry" isColour={true} label='INQUIRY NOW'/>
        </div> </div>
  </div>

</form>
  )
}
export default Form;